import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const AuroraBackground = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Static gradient for mobile - no animations for better performance
  if (isMobile) {
    return (
      <>
        <div className="aurora-glow">
          {/* Static violet blob */}
          <div
            className="absolute w-[600px] h-[600px] rounded-full opacity-25 blur-[80px]"
            style={{
              background: "radial-gradient(circle, hsl(270 60% 50%) 0%, transparent 70%)",
              top: "0%",
              left: "-10%",
            }}
          />
          
          {/* Static cyan blob */}
          <div
            className="absolute w-[400px] h-[400px] rounded-full opacity-20 blur-[60px]"
            style={{
              background: "radial-gradient(circle, hsl(185 70% 45%) 0%, transparent 70%)",
              top: "40%",
              right: "-10%",
            }}
          />
          
          {/* Static deep blue blob */}
          <div
            className="absolute w-[500px] h-[500px] rounded-full opacity-15 blur-[80px]"
            style={{
              background: "radial-gradient(circle, hsl(220 70% 25%) 0%, transparent 70%)",
              bottom: "-5%",
              left: "20%",
            }}
          />
        </div>
        
        {/* Noise texture overlay */}
        <div className="noise-overlay" />
      </>
    );
  }

  // Full animated version for desktop
  return (
    <>
      {/* Aurora gradient mesh */}
      <div className="aurora-glow">
        {/* Primary aurora blob - violet */}
        <motion.div
          className="absolute w-[800px] h-[800px] rounded-full opacity-30 blur-[120px]"
          style={{
            background: "radial-gradient(circle, hsl(270 60% 50%) 0%, transparent 70%)",
            top: "0%",
            left: "-10%",
            willChange: "transform",
          }}
          animate={{
            x: [0, 100, -50, 0],
            y: [0, -80, 50, 0],
            scale: [1, 1.2, 0.9, 1],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        
        {/* Secondary aurora blob - cyan */}
        <motion.div
          className="absolute w-[600px] h-[600px] rounded-full opacity-25 blur-[100px]"
          style={{
            background: "radial-gradient(circle, hsl(185 70% 45%) 0%, transparent 70%)",
            top: "30%",
            right: "-15%",
            willChange: "transform",
          }}
          animate={{
            x: [0, -80, 60, 0],
            y: [0, 100, -60, 0],
            scale: [1, 0.9, 1.15, 1],
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        
        {/* Tertiary aurora blob - deep blue */}
        <motion.div
          className="absolute w-[700px] h-[700px] rounded-full opacity-20 blur-[140px]"
          style={{
            background: "radial-gradient(circle, hsl(220 70% 25%) 0%, transparent 70%)",
            bottom: "-10%",
            left: "30%",
            willChange: "transform",
          }}
          animate={{
            x: [0, 60, -80, 0],
            y: [0, -50, 80, 0],
            scale: [1, 1.1, 0.95, 1],
          }}
          transition={{
            duration: 22,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* Extra glow spot */}
        <motion.div
          className="absolute w-[400px] h-[400px] rounded-full opacity-15 blur-[80px]"
          style={{
            background: "radial-gradient(circle, hsl(280 50% 60%) 0%, transparent 70%)",
            top: "60%",
            left: "10%",
            willChange: "transform",
          }}
          animate={{
            x: [0, 40, -30, 0],
            y: [0, -40, 30, 0],
          }}
          transition={{
            duration: 18,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </div>
      
      {/* Noise texture overlay */}
      <div className="noise-overlay" />
    </>
  );
};

export default AuroraBackground;
